export default {
  value: {
    type: [String, Array],
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  limit: {
    type: Number,
    default: 1,
  },
  enableCrop: {
    type: Boolean,
    default: false,
  },
  cropOptions: {
    type: Object,
    default() {
      return {};
    },
  },
  action: {
    type: String,
    default: "",
  },
  uploadData: {
    type: Object,
    default() {
      return {};
    },
  },
  accept: {
    type: String,
    default: "image/*",
  },
  maxSize: {
    type: Number,
    default: 307200, // 300KB
  },
  listType: {
    type: String,
    default: "picture-card",
  },
  width: {
    type: String,
    default: "148px",
  },
  height: {
    type: String,
    default: "148px",
  },
  showFileList: {
    type: Boolean,
    default: true,
  },
  tip: {
    type: String,
    default: "",
  },
  downloadUrl: {
    type: String,
    default: "",
  },
  beforeUpload: {
    type: Function,
    default: null,
  },
  onSuccess: {
    type: Function,
    default: null,
  },
  onError: {
    type: Function,
    default: null,
  },
  onRemove: {
    type: Function,
    default: null,
  },
  onCrop: {
    type: Function,
    default: null,
  },
};

